import { createFileRoute } from "@tanstack/react-router";
import { ProtectedPage } from "../app/route-boundaries";
import { AdminAIPage } from "../pages/AdminAIPage";
export const Route = createFileRoute("/system/ai/providers")({
  component: () => (
    <ProtectedPage>
      <AdminAIPage section="providers" />
    </ProtectedPage>
  ),
});
